import { useState } from "react";
import NavBar, { Sidebar } from "../components/NavBar";

export default function DashboardShell({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#050d1a] text-white">
      <NavBar onToggleSidebar={() => setSidebarOpen((v) => !v)} />
      <div className="flex">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 min-w-0 px-4 lg:px-10 py-8 max-w-6xl mx-auto" data-testid="dashboard-main">
          {children}
        </main>
      </div>
    </div>
  );
}
